import { IconButton, Menu, MenuContent, MenuTrigger, MenuItem } from '@cad-arc';
import { useDexResults } from './use-dex-results';
import { observer } from 'mobx-react-lite';
import { useClearDexResultsMutation } from './use-clear-dex-results-mutation';

export const DexResultsMoreActionsMenu = observer(
    function DexResultsMoreActionsMenu(): React.ReactElement {
        const clearResultsMutation = useClearDexResultsMutation();
        const { dexResultsStore } = useDexResults();
        const hasResults = !!dexResultsStore.latestStoredDexMessageId;
        return (
            <Menu>
                <MenuTrigger asChild>
                    <IconButton
                        data-testid="dex-results-more-actions-menu"
                        variant="ghost"
                        icon="MoreActions"
                        aria-label="more actions"
                    />
                </MenuTrigger>
                <MenuContent>
                    <MenuItem
                        isDisabled={!hasResults}
                        onSelect={() => clearResultsMutation.mutate()}
                    >
                        Clear All Results
                    </MenuItem>
                </MenuContent>
            </Menu>
        );
    }
);
